module.exports = __webpack_public_path__ + "static/AxaColpatria-c3cf2e52437b17dbcf74f69fe0f35561.png";